<template>
  <div v-if="!hidden">
    <div
      :class="[
        'stepBox',
        {
          passed: mode == 'testing' && condition._passed == true,
          'not-passed': mode == 'testing' && condition._passed == false,
        },
      ]"
      :key="key"
    >
      <v-container>
        <v-row>
          <!-- IF/LEFT -->
          <v-col>
            <div
              class="toggleElement"
              v-if="hasChildren"
              @click="toggleChildren(value, childHiddenFlag)"
            >
              <span v-if="childHiddenFlag"><v-icon small>
      mdi-arrow-down-thick
    </v-icon></span>
              <span v-else><v-icon small>
      mdi-arrow-up-thick
    </v-icon></span>
            </div>
            <scopeField
              :scope="condition.left.scope"
              :field="condition.left.field"
              :constants="constants"
              :mode="mode"
              :_resolved="condition.left._resolved"
            />
          </v-col>

          <!-- OPERATOR -->
          <v-col class="operator">
            <div v-if="condition.operator">{{ condition.operator }}</div>
          </v-col>

          <!-- THEN/RIGHT -->
          <v-col>
            <!-- BETWEEN and OUTSIDE operators -->
            <template
              v-if="
                condition.operator == 'BETWEEN' ||
                  condition.operator == 'OUTSIDE'
              "
            >
              <scopeField
                :isThen="true"
                :scope="condition.right.a.scope"
                :field="condition.right.a.field"
                :value="
                  condition.right.a.value ? condition.right.a.value : null
                "
                :constants="constants"
                :mode="mode"
                :operator="condition.operator"
                :_resolved="
                  condition.right._resolved 
                    ? condition.right._resolved.__values.first.a 
                    : null
                "
                style="flex: 1 1 20px; text-align: center;"
              />
              <div style="flex: 0 1 38px;"><b>and</b></div>

              <scopeField
                :isThen="true"
                :scope="condition.right.b.scope"
                :field="condition.right.b.field"
                :value="
                  condition.right.b.value ? condition.right.b.value : null
                "
                :constants="constants"
                :mode="mode"
                :operator="condition.operator"
                :_resolved="
                  condition.right._resolved
                    ? condition.right._resolved.__values.first.b
                    : null
                "
                style="flex: 1 1 20px; text-align: center;"
              />
            </template>

            <!-- IS NULL and IS NOT NULL operators -->
            <template
              v-if="
                condition.operator == 'IS NULL' ||
                  condition.operator == 'IS NOT NULL'
              "
            >
            </template>

            <!-- all other operators -->
            <template v-else-if="condition.right.scope">
              <scopeField
                :isThen="true"
                :scope="condition.right.scope"
                :field="condition.right.field"
                :value="condition.right.value ? condition.right.value : null"
                :constants="constants"
                :mode="mode"
                :operator="condition.operator"
                :_resolved="condition.right._resolved"
              />
            </template>
          </v-col>
        </v-row>
      </v-container>

      <template v-if="mode == 'default'">
        <div class="actions mt-1">
          <v-btn icon plain small color="grey" @click="editCondition(value)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            icon
            plain
            small
            color="grey"
            @click="deleteCondition(value, parent, index)"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>

        <v-btn
          class="addSubconditionBtn"
          plain
          text
          x-small
          @click.native="addChild(value)"
        >
          <v-icon left x-small>mdi-plus</v-icon>Sub-Condition
        </v-btn>
      </template>

      <template v-else-if="mode == 'testing'">

        <div class="passedPercentage" v-if="condition._passedPercent">
          <span>{{ Math.ceil(condition._passedPercent * 100) }}%</span>
        </div>

        <div class="stepError" v-if="condition._error">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" color="error"
                >mdi-alert-circle</v-icon
              >
            </template>
            <span>{{ condition._error }}</span>
          </v-tooltip>
        </div>
      </template>
    </div>
    <draggable v-model="condition.children" :disabled="mode === 'testing'">
    <condition-box
      v-for="(child, childIndex) in condition.children"
      :key="childIndex"
      :parent="value"
      :hidden="childHiddenFlag"
      :value="child.if"
      :condition="child.if"
      :index="childIndex"
      :class="['mt-2 ml-4']"
      :mode="mode"
      :constants="constants"
      @editCondition="editCondition"
      @deleteCondition="deleteCondition"
      @addChild="addChild"
      @emitToggleChildren="emitToggleChildren"
    />
    </draggable>
  </div>
</template>

<script>
import scopeField from "./showScopeField.vue";
import draggable from 'vuedraggable'

export default {
  components: {
    scopeField,
    draggable
  },

  name: "conditionBox",

  props: {
    value: {
      type: Object,
    },
    condition: {
      type: Object,
    },
    parent: {
      type: Object,
    },
    index: {
      type: Number,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    constants: {
      type: Array,
    },
    stageIndex: {
      type: Number,
    },
    mode: {
      type: String,
      default: "default",
    },
  },

  data() {
    return {
      childHiddenFlag: false,
    };
  },
  created(){
    this.childHiddenFlag = this.hideElement;
  },
  watch:{
    hidden(status){
      this.childHiddenFlag = status;
    }
  },
  computed: {
    hasChildren() {
      return this.condition.children && this.condition.children.length > 0;
    },
    hideElement(){
      return this.$store.getters.isCurrentConditionBoxHidden(this.value);
    }
  },

  methods: {

    editCondition(condition) {
      this.$emit("editCondition", condition, this.stageIndex);
    },

    deleteCondition(condition, parent, index) {
      this.$emit("deleteCondition", condition, parent, index);
    },

    addChild(condition) {
      this.$emit("addChild", condition);
    },

    toggleChildren(condition, status) {
      if (this.hasChildren) {
        this.childHiddenFlag = !status;
      }
      this.emitToggleChildren(condition, this.childHiddenFlag)
    },

    emitToggleChildren(condition, status){

      this.$emit('emitToggleChildren',condition, status);
    }
  },
};
</script>

<style lang="scss">
.toggleElement {
  position: absolute;
  top: 1em;
  left: 1em;
  font-weight: bold;
  font-size: 90%;
  display: block;
  z-index: 100;
  cursor: pointer;
}
</style>
